import { createActionGroup, emptyProps, props } from '@ngrx/store';
import type { Entity } from '../../../core/models/entity.model';

export const LoginEntityActions = createActionGroup({
  source: 'Login entity',
  events: {
    get_entity_start: emptyProps(),
    get_entity_success: props<{ entity: Entity }>(),
    get_entity_fail: props<{ error: any }>(),
    update_entity_success: props<{ entity: Entity }>()
  }
});
